import type { GuideStop } from "@/components/desktop/VovyGuide";

/**
 * Where the flying Vovy parks on VovyDoesSection, in DOM order — the guide
 * picks the last anchor in the active band, so this array has to stay in page
 * order.
 *
 * One stop per mode section (Work, then Explain). Each section leaves a
 * landing pad above its screen, off to the side, so Vovy never covers the
 * demo or the glass card.
 *
 * Its own module so the page can read the stops without statically importing
 * the section itself, which is lazy.
 */
export const VOVY_DOES_STOPS: GuideStop[] = [
  { id: "does-work", large: true, flip: true },
  { id: "does-explain", large: true },
];

export default VOVY_DOES_STOPS;
